import { isFailed, isShowLoader, selectError, useAppSelector } from '@libs/store';
import { ConditionalRender } from '@libs/utils';
import React, { useEffect } from 'react';
import { SpinnerCircle } from './common/SpinnerCircle';
import { CommonScreen } from './CommonScreen/CommonScreen';
import { CrossRoundedIcon } from './utils/CrossRounded';
import styles from './WidgetWrapper.module.css';

export const WidgetWrapper = ({ children }: { children: React.ReactNode }) => {
    const isLoader = useAppSelector(isShowLoader);
    const isStatusFlailed = useAppSelector(isFailed);
    const errors = useAppSelector(selectError);

    useEffect(() => {
        if (isLoader) {
            // @ts-expect-error
            document?.activeElement?.blur?.();
        }
    }, [isLoader]);

    return (
        <>
            <ConditionalRender condition={isStatusFlailed}>
                <CommonScreen color="#F1557F" Icon={CrossRoundedIcon} mainText={errors?.errorMessage} />
            </ConditionalRender>
            <ConditionalRender condition={isLoader}>
                <div className={styles.loaderOverlay}>
                    <CommonScreen Icon={SpinnerCircle} />
                </div>
            </ConditionalRender>
            <ConditionalRender condition={!isStatusFlailed}>{children}</ConditionalRender>
        </>
    );
};
